var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

footerGroup();
cover();
featured();
logoMarquee();
memosHeader();
researchAutoplay();
categoryNav();
podcastLinks();
pageHeaderConfig();
setupNavHighlight({
    navSelector: '.blog-navbar',
    highlightSelector: '.blog-navbar-underline',
    itemSelector: '.blog-navbar-item',
    activeClass: 'is-active'
});

document.addEventListener('DOMContentLoaded', setupFootnotes);

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTOCCollisionDetection);
} else {
    initTOCCollisionDetection();
}

pagination(false);

window.addEventListener('scroll', function () {
    'use strict';
    if (body.classList.contains('home-template') && body.classList.contains('with-full-cover') && !document.querySelector('.cover').classList.contains('half')) {
        if (timeout) {
            window.cancelAnimationFrame(timeout);
        }
        timeout = window.requestAnimationFrame(portalButton);
    }
});

if (document.querySelector('.cover') && document.querySelector('.cover').classList.contains('half')) {
    body.classList.add('portal-visible');
}

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function cover() {
    'use strict';
    var cover = document.querySelector('.cover');
    if (!cover) return;

    imagesLoaded(cover, function () {
        cover.classList.remove('image-loading');
    });

    document.querySelector('.cover-arrow').addEventListener('click', function () {
        var element = cover.nextElementSibling;
        element.scrollIntoView({behavior: 'smooth', block: 'start'});
    });
}

function featured() {
    'use strict';
    var feed = document.querySelector('.news-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 30,
        loop: false,
        nav: false,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
        },
    });
}

function researchAutoplay() {
    'use strict';
    var wrapper = document.querySelector('.research-media');
    if (!wrapper) return;

    var iframe = wrapper.querySelector('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    if (!iframe) return;

    var src = iframe.getAttribute('src');
    var separator = src.indexOf('?') === -1 ? '?' : '&';
    iframe.setAttribute('src', src + separator + 'autoplay=1&mute=1');
}

function logoMarquee() {
    'use strict';
    const marqueeContainer = document.getElementById('logo-marquee');
    if (!marqueeContainer) return;
    
    const logoContainer = marqueeContainer.querySelector('.logo-list-container');
    if (!logoContainer) return;
    
    // Clone logos to create a seamless loop
    const originalLogos = logoContainer.innerHTML;
    logoContainer.innerHTML = originalLogos + originalLogos + originalLogos;
    
    const logoItems = logoContainer.querySelectorAll('.kg-image-card');
    if (!logoItems.length) return;
    
    // Calculate total width of one set of logos
    let singleSetWidth = 0;
    const logoCount = logoItems.length / 3;
    
    for (let i = 0; i < logoCount; i++) {
        const style = window.getComputedStyle(logoItems[i]);
        const width = parseFloat(style.width);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        singleSetWidth += width + marginLeft + marginRight;
    }
    
    // Set initial position
    let currentPosition = 0;
    let animationId;
    let isPaused = false;
    let speed = window.innerWidth > 768 ? 1 : 0.5; // pixels per frame, slower on mobile
    
    // Make sure container is wide enough and positioned correctly
    logoContainer.style.width = (singleSetWidth * 3) + 'px';
    
    // Animation function with smoother reset logic
    function animate() {
        if (!isPaused) {
            currentPosition -= speed;
            
            // Reset position for seamless loop when first set is off-screen
            if (Math.abs(currentPosition) >= singleSetWidth) {
                // Reset by exactly one set width for seamless transition
                currentPosition = currentPosition + singleSetWidth;
            }
            
            logoContainer.style.transform = `translateX(${currentPosition}px)`;
        }
        animationId = requestAnimationFrame(animate);
    }
    
    // Start animation with a slight delay to ensure proper initialization
    setTimeout(() => {
        animationId = requestAnimationFrame(animate);
    }, 100);
    
    // Pause on hover
    marqueeContainer.addEventListener('mouseenter', () => {
        isPaused = true;
    });
    
    marqueeContainer.addEventListener('mouseleave', () => {
        isPaused = false;
    });
    
    // Adjust speed on window resize
    window.addEventListener('resize', () => {
        speed = window.innerWidth > 768 ? 0.4 : 0.2;
    });
    
    // Clean up on page leave
    window.addEventListener('beforeunload', () => {
        cancelAnimationFrame(animationId);
    });
}

function memosHeader() {
    'use strict';
    var header = document.querySelector('[data-memos-header]');
    if (!header) return;

    var imagesContainer = header.querySelector('.memos-header-images-container');
    if (!imagesContainer) return;

    var leftImages = imagesContainer.querySelector('.memos-images-left');
    var rightImages = imagesContainer.querySelector('.memos-images-right');
    var headerInner = header.querySelector('.memos-header-inner');

    // Move left images to proper position
    if (leftImages && headerInner) {
        var leftSlot = document.createElement('div');
        leftSlot.className = 'memos-header-images memos-header-images-left';
        leftSlot.innerHTML = leftImages.innerHTML;
        headerInner.insertBefore(leftSlot, headerInner.firstChild);
    }

    // Move right images to proper position
    if (rightImages && headerInner) {
        var rightSlot = document.createElement('div');
        rightSlot.className = 'memos-header-images memos-header-images-right';
        rightSlot.innerHTML = rightImages.innerHTML;
        headerInner.appendChild(rightSlot);
    }

    // Hide original container (now that images are moved)
    if (imagesContainer) {
        imagesContainer.style.display = 'none';
    }
}

function categoryNav() {
    'use strict';
    var currentPageURL = window.location.pathname;

    // Get all <a> tags inside the .blog-navbar div
    var navbarLinks = document.querySelectorAll('.blog-navbar a');

    // Loop through each <a> tag
    navbarLinks.forEach(function(link) {
        // Check if the href attribute matches the current page URL
        if (link.getAttribute('href') === currentPageURL) {
            // Add the is-active class
            link.classList.add('is-active');
        }
    });
}

function setupNavHighlight({navSelector, highlightSelector, itemSelector, activeClass = 'is-active', onNavLeave = null}) {
    var navbar = document.querySelector(navSelector);
    if (!navbar) return;
    var highlight = navbar.querySelector(highlightSelector);
    var items = navbar.querySelectorAll(itemSelector);
    if (!highlight || !items.length) return;

    function moveHighlightTo(element) {
        var rect = element.getBoundingClientRect();
        var navbarRect = navbar.getBoundingClientRect();
        highlight.style.left = (rect.left - navbarRect.left + navbar.scrollLeft) + 'px';
        highlight.style.width = rect.width + 'px';
    }

    // Set highlight to active item on load without transition
    var activeItem = navbar.querySelector(itemSelector + '.' + activeClass);
    if (activeItem) {
        highlight.style.transition = 'none'; // Disable transition
        moveHighlightTo(activeItem); // Position highlight without animation

        // Force reflow and restore transition after a small delay
        setTimeout(function() {
            highlight.style.transition = '';
        }, 50); // Small delay to ensure correct positioning
    }

    items.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
            if (document.body.classList.contains('is-dropdown-open') || item.closest('.gh-dropdown')) {
                return;
            }
            const dropdownContainer = item.closest('.dropdown');
            if (dropdownContainer) {
                const parentNavItem = dropdownContainer.closest('li.has-dropdown');
                if (parentNavItem) {
                    const parentLink = parentNavItem.querySelector('a');
                    if (parentLink) {
                        moveHighlightTo(parentLink);
                        return;
                    }
                }
            }
            moveHighlightTo(item);
        });
        item.addEventListener('focus', function() {
            if (document.body.classList.contains('is-dropdown-open') || item.closest('.gh-dropdown')) {
                return;
            }
            const dropdownContainer = item.closest('.dropdown');
            if (dropdownContainer) {
                const parentNavItem = dropdownContainer.closest('li.has-dropdown');
                if (parentNavItem) {
                    const parentLink = parentNavItem.querySelector('a');
                    if (parentLink) {
                        moveHighlightTo(parentLink);
                        return;
                    }
                }
            }
            moveHighlightTo(item);
        });
        item.addEventListener('mouseleave', function() {
            if (document.body.classList.contains('is-dropdown-open')) {
                return;
            }
            if (activeItem) moveHighlightTo(activeItem);
        });
        item.addEventListener('blur', function() {
            if (document.body.classList.contains('is-dropdown-open')) {
                return;
            }
            if (activeItem) moveHighlightTo(activeItem);
        });
        item.addEventListener('click', function() {
            // Prevent transition if clicking the active item
            if (item === activeItem) {
                var prevTransition = highlight.style.transition;
                highlight.style.transition = 'none';
                moveHighlightTo(item);
                void highlight.offsetWidth; // force reflow
                highlight.style.transition = prevTransition;
            }
        });
    });

    // Reposition highlight on window resize
    window.addEventListener('resize', function() {
        if (activeItem) moveHighlightTo(activeItem);
    });
    // Reposition highlight on navbar scroll (for horizontal scroll)
    navbar.addEventListener('scroll', function() {
        if (activeItem) moveHighlightTo(activeItem);
    });

    // Hide highlight on nav mouseleave if requested
    if (onNavLeave === 'hide') {
        navbar.addEventListener('mouseleave', function() {
            highlight.style.opacity = '0';
            highlight.style.pointerEvents = 'none';
        });
        navbar.addEventListener('mouseenter', function() {
            highlight.style.opacity = '1';
            highlight.style.pointerEvents = 'auto';
            if (activeItem) moveHighlightTo(activeItem);
        });
    }
}

function podcastLinks() {
    'use strict';
    document.querySelectorAll('[data-podcast-links]').forEach(function(container) {
        var template = container.querySelector('.podcast-meta');
        if (!template) return;

        // Look for script tag with podcast links inside template
        var scriptEl = template.content.querySelector('#podcast-links');
        if (!scriptEl) return;

        var content = scriptEl.textContent.trim();
        var links = {};

        // Parse simple key: value format
        // e.g. "spotify: https://..." or "apple: https://..."
        var lines = content.split(/[\n\r]+/);
        lines.forEach(function(line) {
            var match = line.match(/^\s*(spotify|apple|youtube)\s*:\s*(https?:\/\/\S+)/i);
            if (match) {
                links[match[1].toLowerCase()] = match[2].trim();
            }
        });

        var spotifyUrl = links.spotify || null;
        var appleUrl = links.apple || null;

        // Determine CTA link (prefer Spotify, then Apple)
        var ctaUrl = spotifyUrl || appleUrl;

        // Show Listen to Episode CTA
        if (ctaUrl) {
            var cta = container.querySelector('.feed-podcast-cta');
            if (cta) {
                cta.href = ctaUrl;
                cta.style.display = 'inline-flex';
            }
        }

        // Populate and show Apple link
        if (appleUrl) {
            var appleLink = container.querySelector('.feed-podcast-apple');
            if (appleLink) {
                appleLink.href = appleUrl;
                appleLink.style.display = 'flex';
            }
        }

        // Populate and show Spotify link
        if (spotifyUrl) {
            var spotifyLink = container.querySelector('.feed-podcast-spotify');
            if (spotifyLink) {
                spotifyLink.href = spotifyUrl;
                spotifyLink.style.display = 'flex';
            }
        }
    });
}

function pageHeaderConfig() {
    'use strict';
    var container = document.querySelector('[data-page-header-config]');
    if (!container) return;

    var template = container.querySelector('.page-header-meta');
    if (!template) return;

    // Parse JSON from code injection
    var scriptEl = template.content.querySelector('#page-header-config');
    if (!scriptEl) return;

    var config;
    try {
        config = JSON.parse(scriptEl.textContent);
    } catch (e) {
        console.warn('Invalid page-header-config JSON:', e);
        return;
    }

    // Render stats from JSON
    if (config.stats && config.stats.length) {
        var statsEl = container.querySelector('.page-header-stats');
        if (statsEl) {
            statsEl.innerHTML = config.stats.map(function(stat) {
                return '<div class="stat-item">' +
                    '<h3 class="stat-value">' + stat.value + '</h3>' +
                    '<span class="stat-label">' + stat.label + '</span>' +
                '</div>';
            }).join('');
        }
    }
}

function footerGroup() {
    const footerNav = document.querySelector(".footer-nav");
    if (!footerNav) return;

    const items = document.querySelectorAll(".footer-nav .nav li");
    
    if (!footerNav || !items.length) return;
    
    const groups = [];
    let index = null;

    // Process all items first
    items.forEach(item => {
        const text = item.textContent.trim();
        const PREFIXFOOTERHEADER = "#";
        if (text.includes(PREFIXFOOTERHEADER)) {
            index = index === null ? 0 : ++index;
            groups[index] = { header: "", items: [] };
            groups[index].header = text.slice(PREFIXFOOTERHEADER.length);
        } else if (index !== null) {
            const link = item.querySelector('a');
            if (link) {
                groups[index].items.push({ text, link: link.href });
            }
        }
    });

    // Only proceed if we found groups
    if (groups.length === 0) return;

    // Add class to footer-middle to indicate grouped navigation
    const footerMiddle = document.querySelector('.footer-middle');
    if (footerMiddle) {
        footerMiddle.classList.add('is-footer-group');
    }

    // Find the social-links element to move it last
    const socialLinks = footerNav.querySelector('.social-links');

    // Create the new structure
    groups.forEach((group) => {
        const div = document.createElement('div');
        div.classList.add("footer-nav-group");
        const h6 = document.createElement('div');
        h6.classList.add("footer-group-header");
        h6.innerHTML = group.header;
        const ul = document.createElement("ul");
        ul.classList.add("nav");
        group.items.forEach((item) => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${item.link}">${item.text}</a>`;
            ul.append(li);
        });
        div.append(h6, ul);
        footerNav.appendChild(div);
    });

    // Move social-links to the end if it exists
    if (socialLinks && socialLinks.parentNode) {
        footerNav.appendChild(socialLinks);
    }

    // Remove the old nav if we have new content
    if (groups.length > 0) {
        const oldNav = document.querySelector(".footer-nav ul.nav");
        if (oldNav && oldNav.parentNode) {  // Check if element exists and has a parent
            oldNav.remove();
        }
    }
}

function setupFootnotes() {
    'use strict';
    const contentSelector = 'article.ghost-content';
    const contentElement = document.querySelector(contentSelector);
    if (!contentElement) return;

    let htmlContent = contentElement.innerHTML;
    const regexPattern = /\[\^(.*?)\]/g;
    
    // Check if there are any footnotes before proceeding
    const matches = htmlContent.match(regexPattern);
    if (!matches) return;

    const footnoteList = document.createElement('ol');
    footnoteList.classList.add('footnote-list');
    footnoteList.id = 'footnotes';
    
    const footnoteWrapper = document.createElement('div');
    footnoteWrapper.classList.add('kg-canvas', 'section-footnotes');
    
    let index = 1;
    
    htmlContent = htmlContent.replace(regexPattern, (match, p1) => {
        footnoteList.innerHTML = footnoteList.innerHTML + `<li id="footnote-${index}">${p1}</li>`;
        const returnValue = `<sup class="footnote"><a href="#footnote-${index}">[${index}]</a></sup>`;
        index++;
        return returnValue;
    });

    contentElement.innerHTML = htmlContent;
    
    footnoteWrapper.appendChild(footnoteList);
    contentElement.appendChild(footnoteWrapper);
}

function initTOCCollisionDetection() {
    'use strict';

    const tocContainer = document.querySelector('.toc-container');
    const tocSidebar = document.querySelector('.toc-sidebar');
    if (!tocContainer || !tocSidebar) return;

    // Elements that break out of the main column into the right gutter
    const conflictingSelector =
        '.kg-canvas > blockquote.kg-blockquote-alt, ' +
        '.kg-width-wide, .kg-width-full, ' +
        '.gh-content table';

    let ticking = false;
    let resizeTimer;

    function checkTOCCollisions() {
        ticking = false;

        const tocRect = tocSidebar.getBoundingClientRect();

        // Hidden or static (mobile) TOC
        if (tocRect.width === 0 || tocRect.height === 0) return;

        // Shrink the TOC box so elements that only graze its edge are ignored
        const margin = 20;
        let hasCollision = false;

        // Queried each time so late content (embeds, footnotes) is included
        const elements = document.querySelectorAll(conflictingSelector);

        for (let i = 0; i < elements.length; i++) {
            const rect = elements[i].getBoundingClientRect();
            if (rect.width <= 0 || rect.height <= 0) continue;

            const isOverlapping = !(
                rect.right < tocRect.left + margin ||
                rect.left > tocRect.right - margin ||
                rect.bottom < tocRect.top + margin ||
                rect.top > tocRect.bottom - margin
            );

            if (isOverlapping && rect.bottom > 0 && rect.top < window.innerHeight) {
                hasCollision = true;
                break;
            }
        }

        tocContainer.classList.toggle('toc-fade-out', hasCollision);
    }

    function requestCheck() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(checkTOCCollisions);
    }

    setTimeout(requestCheck, 100);

    window.addEventListener('scroll', requestCheck, {passive: true});

    window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(requestCheck, 50);
    });

    // Images that load late shift element positions
    document.querySelectorAll('.gh-content img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', requestCheck);
    });
}
